import { Body, Controller, Param, Post, Put } from '@nestjs/common'
import { Sequelize } from 'sequelize-typescript'
import { IAplicacion, SistemaMensajeria } from '../../../interfaces'
import { WebhookAplicacionService } from '../services/aplicacion.server.services'

@Controller('plataforma')
export class PlataformaController {
  constructor(private aplicacionService: WebhookAplicacionService, private sequelize: Sequelize) {}

  @Post()
  async post(@Body() data: any) {
    //TODO: agregar Dto
    const plataforma: IAplicacion = Object.assign({}, data)
    const aplicacionIden = await this.aplicacionService.obtenerAplicacion(plataforma.identificador)

    if (aplicacionIden) {
      return { status: 'error', apiKey: plataforma.apiKey, error: 'Aplicación ya agregada' }
    }
    plataforma.apiKey = Array(39)
      .fill(null)
      .map(() => Math.round(Math.random() * 16).toString(16))
      .join('')

    if (plataforma.redirect != '') {
      plataforma.redirect = `https://${plataforma.redirect}/api/chat`
    } else plataforma.redirect = 'https://palacevacationclub.mx/api/chat'
    await this.aplicacionService.agregarAplicacion({
      ...plataforma,
      capturaFecha: new Date(),
    })
    return { status: 'add', apiKey: plataforma.apiKey }
  }

  @Put(':identificador')
  async put(@Body() data: SistemaMensajeria, @Param('identificador') identificador: string) {
    const aplicacionIden = await this.aplicacionService.obtenerAplicacion(identificador)

    if (aplicacionIden) {
      if (data.token === aplicacionIden.token)
        return { status: 'error', apiKey: aplicacionIden.apiKey, error: 'Aplicación ya agregada' }
      if (data.token) await this.aplicacionService.actualizarAccessToken(aplicacionIden.id, data.token)
      console.log(data, 'data')
      await this.aplicacionService.actualizar(aplicacionIden.id, {
        nombre: data.nombre,
        identificador: data.identificador,
      })
      return { status: 'update', apiKey: aplicacionIden.apiKey }
    }
  }
}
